import { render, staticRenderFns } from "./CardAdvantage.vue?vue&type=template&id=94ef30fa&"
import script from "./CardAdvantage.vue?vue&type=script&lang=js&"
export * from "./CardAdvantage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports